import * as React from "react";
import { observer } from "mobx-react";
import * as moment from "moment";
import { Layout, Button } from "antd";
import { injectIntl, InjectedIntlProps, FormattedMessage } from "react-intl";
import {priceStore } from "../../../models/PriceStore";
import { Link } from "@netless/i18n-react-router";
import {
    Chart,
    LineAdvance,
} from "bizcharts";
import { dataStore } from "src/models/DataStore";
import { WhiteboardDuration } from "../dataCenter/WhiteboardData";
import { roomStore } from "src/models/RoomStore";
import QuickStart from "./QuickStart";
import {ServiceTypeEnum} from "../serviceCenter/ProjectDetail";
import DriverInf from "./DriverInf";
const { Content } = Layout;

export type DashboardProps = InjectedIntlProps;

export type DashboardStates = {
    productType: ServiceTypeEnum;
};

@observer
class Dashboard extends React.Component<DashboardProps, DashboardStates> {

    public constructor(props: DashboardProps) {
        super(props);
        this.state = {
            productType: ServiceTypeEnum.room,
        };
    }

    public async componentDidMount(): Promise<void> {
        await priceStore.getMyBalance();
        await priceStore.getCoupons();
        const timestamp = new Date().getTime();
        const endDay = moment(timestamp).startOf("day").valueOf();
        const startDay = moment(timestamp).subtract(7, "d").startOf("day").valueOf();
        await dataStore.getTeamWhiteboardData(startDay, endDay);
        await roomStore.getService();
    }

    public render(): React.ReactNode {
        const { intl } = this.props;
        let writableDayDataArray: WhiteboardDuration[] = [];
        let readonlyDayDataArray: WhiteboardDuration[] = [];
        if (dataStore.team_duration.length > 0) {
            writableDayDataArray = dataStore.team_duration.map(data => {
                return {
                    date: moment(data.timestamp).format("MMM Do"),
                    duration: data.writableDuration,
                    type: intl.formatMessage({ id: "dash.whiteboard-writable-duration" }),
                };
            });
            readonlyDayDataArray = dataStore.team_duration.map(data => {
                return {
                    date: moment(data.timestamp).format("MMM Do"),
                    duration: data.readonlyDuration,
                    type: intl.formatMessage({ id: "dash.whiteboard-readonly-duration" }),
                };
            });
        }
        const dayDataArray = [...writableDayDataArray, ...readonlyDayDataArray];
        return (
            <div className="console-out-box" style={{ paddingTop: 16 }}>
                <div className="console-balance-box">
                    <Content className="console-balance">
                        <div className="console-content-title">
                            <span className="console-content-title-text">
                                {intl.formatMessage({ id: "account-balance" })}
                            </span>
                        </div>
                        <div className="console-balance-number">
                            <div className="console-balance-number-text">
                                {priceStore.balanceData ? priceStore.balanceData : 0}
                            </div>
                            {/* <div className="console-balance-number-btn">
                                <Link to="/finance/pay/">
                                    <Button
                                        size="large"
                                        type="primary"
                                        htmlType="submit"
                                        className="console-balance-recharge"
                                    >
                                        {intl.formatMessage({ id: "global.recharge" })}
                                    </Button>
                                </Link>
                            </div> */}
                        </div>
                    </Content>
                    {/* <DriverInf/>
                    <QuickStart/> */}
                </div>
                <Content className="console-service">
                    <div className="console-content-title">
                        <span className="console-content-title-text">
                            <FormattedMessage
                                    id="dash.whiteboard-writable-duration"
                                />
                        </span>
                        <Link to={`/data/whiteboard/`}>
                            <div className="console-account-cell-btn">
                                <FormattedMessage
                                    id="global.more"
                                />
                            </div>
                        </Link>
                    </div>
                    <div className="console-content-inner" style={{ marginTop: 48 }}>
                        <div className="console-service-text">
                            <FormattedMessage
                                id="global.total"
                            />
                        </div>
                        <div className="console-service-add">
                            {dataStore.writableDurationDayAdded} <FormattedMessage
                                id="global.minute"
                            /></div>
                        <Chart autoFit
                               padding={[20, 120, 96, 120]}
                               width={1200}
                               height={300}
                               data={dayDataArray}>
                            <LineAdvance
                                shape="smooth"
                                point
                                area
                                position="date*duration"
                                color={["type", ["#3381FF", "#3DC797"]]}
                            />
                        </Chart>
                    </div>
                </Content>
                {/*<Content style={{marginTop: 16}} className="console-service">*/}
                {/*    <div className="console-content-title">*/}
                {/*        <span className="console-content-title-text">*/}
                {/*            <FormattedMessage*/}
                {/*                    id="dash.whiteboard-readonly-duration"*/}
                {/*                />*/}
                {/*        </span>*/}
                {/*        <Link to={`/data/whiteboard/`}>*/}
                {/*            <div className="console-account-cell-btn">*/}
                {/*                <FormattedMessage*/}
                {/*                    id="global.more"*/}
                {/*                />*/}
                {/*            </div>*/}
                {/*        </Link>*/}
                {/*    </div>*/}
                {/*    <div className="console-content-inner" style={{ marginTop: 48 }}>*/}
                {/*        <div className="console-service-text">*/}
                {/*            <FormattedMessage*/}
                {/*                id="global.total"*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*        <div className="console-service-add">*/}
                {/*            {dataStore.readonlyDurationDayAdded} <FormattedMessage*/}
                {/*                id="global.minute"*/}
                {/*            /></div>*/}
                {/*        <Chart autoFit*/}
                {/*               padding={[20, 120, 96, 120]}*/}
                {/*               width={1200}*/}
                {/*               height={300}*/}
                {/*               data={readonlyDayDataArray}>*/}
                {/*            <LineAdvance*/}
                {/*                shape="smooth"*/}
                {/*                point*/}
                {/*                area*/}
                {/*                position="date*duration"*/}
                {/*                color={["type", ["#3381FF"]]}*/}
                {/*            />*/}
                {/*        </Chart>*/}
                {/*    </div>*/}
                {/*</Content>*/}
            </div>
        );
    }
}

export default injectIntl(Dashboard);



// WEBPACK FOOTER //
// ./src/components/portal/dashboard/Dashboard.tsx